<template>
    <div>
        <div class="row">
            <div class="col-md-12 ">
                <div class="panel panel-default">
                    <div class="panel-heading">Status of Your Extents</div>

                    <div class="panel-body">
                        <el-row>
                            <el-table
                                    :data="table_data"
                                    style="width: 100%">
                                <el-table-column
                                        v-for = "column in columns"
                                        v-bind:label = column.label
                                        v-bind:prop = column.prop
                                        sortable
                                >
                                    <template slot-scope="scope">
                                        <div v-if="column.prop==='extent_name'">
                                            <div v-if="scope.row['extent_type']==='Client'" style="color:lightgray;padding-left:0px;">
                                                {{ scope.row[column.prop] }}
                                            </div>
                                            <div v-else-if="scope.row['extent_type']==='SiteGroup'" style="color:darkgray;padding-left:15px;">
                                                {{ scope.row[column.prop] }}
                                            </div>
                                            <div v-else style="color:black;padding-left:30px;">
                                                {{ scope.row[column.prop] }}
                                            </div>
                                        </div>
                                        <div v-else-if="column.prop==='current'" style="width:5%">
                                            <div v-if="scope.row['current']">
                                                {{ scope.row['current']}}
                                            </div>
                                        </div>
                                        <div v-else-if="column.prop==='last_successful_crawl'">
                                            <div v-if="scope.row['last_successful_crawl_progress_url']">
                                                <a :href="scope.row['last_successful_crawl_progress_url']">
                                                    {{ scope.row['last_successful_crawl'] }}
                                                </a>
                                            </div>
                                            <div v-else>
                                                {{ scope.row['last_successful_crawl'] }}
                                            </div>

                                        </div>
                                        <div v-else>
                                            {{ scope.row[column.prop] }}
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-row>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        mounted() {
            axios.get("/api/user/extents_status")
                .then(response => {
                    console.log(response.data)
                    this.table_data = response.data
                })
                .catch(error => {
                    console.log("Could not get extents status for user")
                })
        },
        data() {
            return {
                table_data: null,
                columns: [
                    {prop: "current", label:""},
                    {prop: "extent_name", label:"Extent Name"},
                    {prop: "last_successful_crawl", label:"Last Successful Crawl"}
                ]
            }
        }
    }
</script>